









































































































import { defineComponent, ref, computed, PropType, watch, useContext } from '@nuxtjs/composition-api';
import ProductDetailPopover from '~/components/pages/Product/Detail/ProductDetailPopover.vue';
import ProductWineBarGraph from '~/components/pages/Product/ProductWineBarGraph.vue';
import ProductWineColorLabel from '~/components/pages/Product/ProductWineColorLabel.vue';
import AppIcon from '~/components/partials/App/AppIcon.vue';
import AppImage from '~/components/partials/App/AppImage.vue';
import AppPrice from '~/components/partials/App/AppPrice.vue';
import ProducingAreaFlag from '~/components/partials/ProducingArea/ProducingAreaFlag.vue';
import ProductAmountButton from '~/components/partials/Product/ProductAmountButton.vue';
import { STOCK_NOTICE_BORDERLINE_COUNT, RATING_COUNT } from '~/constants/products';
import { filterReviewRating } from '~/utils/modules/products';
import { ProductDetailFlexibleSetItem } from '~/types/modules/product';

export default defineComponent({
  components: {
    AppIcon,
    AppImage,
    AppPrice,
    ProducingAreaFlag,
    ProductWineColorLabel,
    ProductWineBarGraph,
    ProductDetailPopover,
    ProductAmountButton,
  },
  props: {
    totalLimit: {
      type: Number,
      required: true,
    },
    data: {
      type: Object as PropType<ProductDetailFlexibleSetItem>,
      required: true,
    },
    selectedTotal: {
      type: Number,
      required: true,
    },
  },
  setup(props, { emit }) {
    const { i18n } = useContext();
    const count = ref(0);
    const maxCount = computed(() =>
      Math.min(props.data.stockCount, props.totalLimit - props.selectedTotal, props.data.quantity - count.value)
    );
    const message = computed(() => {
      if (props.data.stockCount <= 0) {
        return i18n.t('Item-10.flexibleItem.annotation.outOfStock').toString();
      }
      if (props.data.stockCount <= STOCK_NOTICE_BORDERLINE_COUNT) {
        return i18n.t('Item-10.flexibleItem.annotation.limitedStock').toString();
      }
      return i18n
        .t('Item-10.flexibleItem.annotation.count', {
          count: Math.min(props.data.stockCount, props.totalLimit, props.data.quantity),
        })
        .toString();
    });

    watch(count, () => emit('updateCount', { data: props.data, quantity: count.value }));

    return {
      props,
      maxCount,
      count,
      message,
      RATING_COUNT,
      filterReviewRating,
    };
  },
});
